import { useMutation } from "react-query";
import api from "../../client";

const deleteData = async (id: string | undefined): Promise<void> => {
  const { data } = await api.delete(`/profile/${id}`);

  return data;
};

export const useDeletePeople = () => {
  return useMutation((id: string | undefined) => {
    return deleteData(id);
  });
};
